<template>
  <Modal>
    <template v-slot:header>
      {{ $t('LOGIN_activeSesion') }}
    </template>

    <template v-slot:body>
      <div class="bodyContainer">
        <div class="imagen">
          <img src="../../images/sesion_activa.png" width="40" />
        </div>
        <div class="texto">{{ message }}</div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="footerContainer">
        <div v-if="cerrandoSesion" class="loaderContainer">
          <div v-loading=true></div>
        </div>

        <div v-else>
          <el-button :data-testid="TEST_ID.LOGIN.BUTTON_FORCE_CLOSE_SESSION" type="primary" @click="onForzarCierreSesion">{{ $t('LOGIN_forceCloseBtn') }}</el-button>
          <el-button :data-testid="TEST_ID.LOGIN.BUTTON_ACTIVE_SESSION_CANCEL" type="default" @click="onCloseModal">{{ $t('GENERAL_cancelBtn') }}</el-button>
        </div>
      </div>

      
    </template>
  </Modal>
</template>

<script>
  import Modal from '../Modal/index'
  import { showError, showSuccess } from '../Mensaje'
  import TEST_ID from '@/testIds.json'

  export default {
    name: 'SesionActivaModal',
    components: { Modal },
    props: { 
      username: String,
      sesionActiva: String,
      onCloseModal: Function
    },
    data() {
      return {
        TEST_ID,
        forzandoCierreSesion: false
      }
    },
    computed: {
      message() {
        let rawMsg = this.$t('LOGIN_activeSessionMsg')
        return rawMsg.replace('[USERNAME]', this.username)
      }
    },
    methods: {
      onForzarCierreSesion() {
        // indico que se está forzando el cierre de sesión
        this.forzandoCierreSesion = true
        
        // fuerzo el cierre de sesión en el servidor
        let payload = { sesion: this.sesionActiva }
        this.$store.dispatch("sesion/cerrarSesion", payload)
        .then(codigoResultado => {
          if(codigoResultado === 0)
            showSuccess(this.$t('LOGIN_activeSesionClosed'))
          
          else
            showError(this.$t('LOGIN_activeSesionError'))
        }) 
        .finally(() => { 
          this.forzandoCierreSesion = false
          this.onCloseModal()
        })      
      },
    }
  }

</script>

<style scoped>

 .bodyContainer {
    display: inline-block;
    width: 100%;
  }

  .bodyContainer .imagen {
    width: 40px; 
    float: left
  }

  .bodyContainer .texto {
    text-align: left;
    padding: 2px 0px;
    width: calc(100% - 60px);
    float: right;
  }

  .footerContainer {
    text-align: right;
  }

  .loaderContainer {
    display: inline-block;
    margin-right: 40px;
    padding: 18px 0px;
  }

  @media(max-width: 425px) 
  {
    .footerContainer .el-button {
      width: 100%;
    }

    .footerContainer .el-button:last-child {
      margin-top: 10px;
      margin-left: 0px;
    }
  }

</style>